// structuredClone
(function () {
  if (typeof window.structuredClone === 'function') return false;

  function structuredClone(data: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(JSON.stringify(data));
  }

  window.structuredClone = structuredClone;
})();
